import { render, staticRenderFns } from "./TranscriptBackground.vue?vue&type=template&id=35ff0430&scoped=true"
import script from "./TranscriptBackground.vue?vue&type=script&lang=js"
export * from "./TranscriptBackground.vue?vue&type=script&lang=js"
import style0 from "./TranscriptBackground.vue?vue&type=style&index=0&id=35ff0430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff0430",
  null
  
)

export default component.exports